import React from "react";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import PhoneDisabledIcon from "@mui/icons-material/PhoneDisabled";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import CallEndIcon from "@mui/icons-material/CallEnd";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import EditNoteIcon from "@mui/icons-material/EditNote";
import PhoneIcon from "@mui/icons-material/Phone";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import PersonIcon from "@mui/icons-material/Person";
import HomeIcon from "@mui/icons-material/Home";
import ContactsIcon from "@mui/icons-material/Contacts";
import StoreIcon from "@mui/icons-material/Store";
import BadgeIcon from "@mui/icons-material/Badge";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import AssessmentIcon from "@mui/icons-material/Assessment";
import BlockIcon from "@mui/icons-material/Block";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import TwoWheelerIcon from "@mui/icons-material/TwoWheeler";
import NotListedLocationIcon from "@mui/icons-material/NotListedLocation";
import DoNotDisturbIcon from "@mui/icons-material/DoNotDisturb";
import MoneyOffIcon from "@mui/icons-material/MoneyOff";
import WorkIcon from "@mui/icons-material/Work";
import { PiSignatureLight, PiTimerLight, PiNewspaperBold } from "react-icons/pi";
import { SiLinkfire, SiGoogledocs } from "react-icons/si";
import { BsPersonBadge, BsPersonBadgeFill } from "react-icons/bs";
import { FaFileSignature } from "react-icons/fa6";

// Funciones puras: dado un id de estado devuelven el ícono correspondiente.
// Extraídas tal cual de ListadoSolicitud.js, sin cambiar casos ni colores.

export const getIconByEstadoDocumental = (estadoId) => {
  switch (estadoId) {
    case 1: // Estado "Aprobado"
      return <UploadFileIcon sx={{ color: "rgb(117, 117, 117)" }} />; // Estado por defecto
    case 2: // Estado "En revisión"
      return <FactCheckIcon sx={{ color: "rgb(30, 136, 229)" }} />;
    case 3: // Estado "Corrección"
      return <ReportProblemIcon sx={{ color: "rgb(251, 140, 0)" }} />;
    case 4: // Estado "Aprobado"
      return <CheckCircleIcon sx={{ color: "rgb(56, 142, 60)" }} />;
    case 5: // Estado "Rechazado"
      return <HighlightOffIcon sx={{ color: "#DC3545" }} />;
  }
};

export const getPhoneIconByEstado = (estado) => {
  switch (estado) {
    case 1: // NO ASIGNADO
      return <PhoneDisabledIcon />;
    case 2: // ASIGNADO
      return <PersonSearchIcon sx={{ color: "rgb(10, 80, 106)" }} />;
    case 3: // Aprobado
      return <CheckCircleIcon sx={{ color: "rgb(56, 142, 60)" }} />;
    case 4: // rechazado
      return <CallEndIcon sx={{ color: "rgb(239, 83, 80)" }} />;
    case 5:
      return <PhoneInTalkIcon sx={{ color: "#DC3545" }} />;
    case 7: // correccion
      return <EditNoteIcon sx={{ color: "rgb(251, 140, 0)" }} />;
    default: // Estado no especificado
      return <PhoneIcon />;
  }
};

export const getSolicitudIconByEstado = (estado) => {
  switch (estado) {
    case 1: // PENDIENTE
      return <SupervisorAccountIcon sx={{ color: "gray" }} />;
    case 2: // DATOS CLIENTE
      return <PersonIcon sx={{ color: "gray" }} />;
    case 3: // DATOS DOMICILIO
      return <HomeIcon sx={{ color: "gray" }} />;
    case 4: // DATOS CÓNYUGE
      return <SupervisorAccountIcon sx={{ color: "gray" }} />;
    case 5: // DATOS REFERENCIAS
      return <ContactsIcon sx={{ color: "gray" }} />;
    case 6: // DATOS NEGOCIO
      return <StoreIcon sx={{ color: "gray" }} />;
    case 7: // DATOS DEPENDIENTE
      return <BadgeIcon sx={{ color: "gray" }} />;
    case 8: // INFORMACIÓN DE CRÉDITO
      return <CreditScoreIcon sx={{ color: "gray" }} />;
    case 9: // FACTORES DE CRÉDITO
      return <AssessmentIcon sx={{ color: "gray" }} />;
    case 10: // verificaciomn
      return <CheckCircleIcon sx={{ color: "rgb(30, 136, 229)" }} />;
    case 11:
      return <EditNoteIcon sx={{ color: "rgb(251, 140, 0)" }} />; // Azul para CORRECCIÓN
    case 12:
      return <CheckCircleIcon sx={{ color: "rgb(56, 142, 60)" }} />;
    case 13:
      return <BlockIcon sx={{ color: "rgb(211, 47, 47)" }} />; // Rojo para RECHAZADO
    // Verde para COMPLETADO
    default: // Default icon si el estado es desconocido
      return <HourglassEmptyIcon sx={{ color: "gray" }} />; // Fallback icon
  }
};

export const getIconDomicilio = (estadoId) => {
  switch (estadoId) {
    case 0: // Sin verificar
      return <HomeIcon sx={{ color: "gray" }} />;

    case 1: // Dirección incorrecta
      return <TwoWheelerIcon sx={{ color: "rgb(30, 136, 229)" }} />;

    case 2: // Aprobado
      return <CheckCircleIcon sx={{ color: "#28A745" }} />;

    case 3: // Malas referencias
      return <ReportProblemIcon sx={{ color: "#DC3545" }} />;

    case 4: // No vive ahí
      return <NotListedLocationIcon sx={{ color: "#DC3545" }} />;

    case 5: // Datos falsos
      return <DoNotDisturbIcon sx={{ color: "#DC3545" }} />;

    case 6: // Zona vetada
      return <BlockIcon sx={{ color: "#6c757d" }} />;

    case 7: // No sustenta ingresos
      return <MoneyOffIcon sx={{ color: "#FFC107" }} />;

    default:
      return <HomeIcon sx={{ color: "gray" }} />;
  }
};

export const getIconLaboral = (estadoId) => {
  switch (estadoId) {
    case 0: // Sin verificar
      return <WorkIcon sx={{ color: "gray" }} />;

    case 1: // Dirección incorrecta
      return <TwoWheelerIcon sx={{ color: "rgb(30, 136, 229)" }} />;

    case 2: // Aprobado
      return <CheckCircleIcon sx={{ color: "#28A745" }} />;

    case 3: // Malas referencias
      return <ReportProblemIcon sx={{ color: "#DC3545" }} />;

    case 4: // No vive ahí
      return <NotListedLocationIcon sx={{ color: "#DC3545" }} />;

    case 5: // Datos falsos
      return <DoNotDisturbIcon sx={{ color: "#DC3545" }} />;

    case 6: // Zona vetada
      return <BlockIcon sx={{ color: "#6c757d" }} />;

    case 7: // No sustenta ingresos
      return <MoneyOffIcon sx={{ color: "#FFC107" }} />;

    default:
      return <HomeIcon sx={{ color: "gray" }} />;
  }
};

// Mapas estáticos id -> { icon, tooltip } usados en la columna "Digital" de la tabla.
export const firmaElectronicaIcons = {
  0: { icon: <PiSignatureLight size={25} color="#9ca3af" />, tooltip: "NO APLICA FIRMA DIGITAL" },
  1: { icon: <PiSignatureLight size={25} color="#2563eb" />, tooltip: "APLICA FIRMA DIGITAL" },
  2: { icon: <SiLinkfire size={30} color="#eab308" />, tooltip: "LINK ENVIADO" },
  3: { icon: <BsPersonBadge size={30} color="#22c55e" />, tooltip: "ACEPTADO" },
  4: { icon: <span className="animate-pulse inline-flex"><BsPersonBadgeFill size={30} color="#dc2626" /></span>, tooltip: "PRUEBA_VIDA_PROCESANDO" },
  5: { icon: <span className="animate-pulse inline-flex"><PiTimerLight size={30} color="#dc2626" /></span>, tooltip: "PRUEBA_VIDA" },
  6: { icon: <PiNewspaperBold size={30} color="#16a34a" />, tooltip: "DOCUMENTO" },
  7: { icon: <SiGoogledocs size={30} color="#dc2626" />, tooltip: "RECHAZADO" },
  /* 8 CADUCADO 9 /* YUPANA NEW CREDITO OK 10 YUPANA ERROR NEW CREDITO */
  8: { icon: <PiNewspaperBold size={30} color="#facc15" />, tooltip: "CADUCADO" },
  9: { icon: <FaFileSignature size={30} color="#16a34a" />, tooltip: "YUPANA NEW CREDITO OK" },
  10: { icon: <FaFileSignature size={30} color="#dc2626" />, tooltip: "YUPANA ERROR NEW CREDITO" },
};

export const tipoFirmaElectronicaIcons = {
  0: { icon: <PiSignatureLight size={25} color="#F7F5F5" />, tooltip: "" },
  1: { icon: <PiSignatureLight size={25} color="#2563eb" />, tooltip: "Firma electrónica disponible Yupana" },
  2: { icon: <SiLinkfire size={30} color="#eab308" />, tooltip: "Firma electrónica disponible Solidario" },
};
